export enum ScheduleType {
  REPEATING = 0,
  SINGLE_SHIFT = 1,
}

export const SINGLE_SHIFT_SUFFIX = "(single)";
